import React from 'react';
import Titulo from '../layout/Titulo';
import ProjetoCard from './ProjetoCard';

// imagens
import projectBauColecionador from '../../assets/images/projects/Bau-do-colecionador.jpg';
import projectEquityGuide from '../../assets/images/projects/Equity Guide.jpg';
import projectTerm from '../../assets/images/projects/termometro.jpg';
import projectSafeProfit from '../../assets/images/projects/SafeProfit.jpg';
import projectBruno from '../../assets/images/projects/Bruno.jpg';
import projectOrigens from '../../assets/images/projects/Origens.jpg';
import programa from '../../assets/aplicativo/Instalador Equity Guide.exe';

import { NavLink } from 'react-router-dom';

const Projetos = () => {
  return (
    <section
      id="projetos"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Titulo title="Conheça alguns dos meus Projetos" desc="Projetos" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 xl:gap-14 pb-8">
        <ProjetoCard
          title="Equity Guide"
          desc="Projeto criado em Python, para auxiliar pessoas a escolher as melhores estrategias para seus investimentos"
          src={projectEquityGuide}
          linkDownload={programa}
          linkVideo="https://youtu.be/dLnwQquCo8k?si=8EqRWlldviOqgrbF"
        />
        <ProjetoCard
          title="Sistema Safe Profit"
          desc="Sistema de automação para compra e venda de criptomoedas no site da Binance."
          src={projectSafeProfit}
          linkSite="http://sistema.safeprofit.com.br/"
          linkVideo="https://youtu.be/w0GOty7skKI"
        />
        <ProjetoCard
          title="Baú do Colecionador"
          desc="Sistema criado para auxiliar um cliente a divulgar, comprar e vender seus produtos de colecionismo, prata, outro, cédulas, moedas, etc."
          src={projectBauColecionador}
          linkSite="https://www.baudocolecionador.com.br/"
          linkVideo="https://youtu.be/w0GOty7skKI"
        />
        <ProjetoCard
          title="Origens da terra"
          desc="Sistema criado em C# e angular, para auxiliar a venda e divulgação de produtos naturais, realizada por produtores locais e micro produtores"
          src={projectOrigens}
          linkSite="https://origens-five.vercel.app/"
          extraText="Backend pausado na AWS"
        />
        <ProjetoCard
          title="Psicólogo Bruno Carlos"
          desc="Site criado para apresentar os serviços oferecidos pelo cliente e divulgar seu canal no youtube."
          linkSite="https://psicologobrunocarlos.com.br/"
          src={projectBruno}
        />
        <ProjetoCard
          title="Termômetro"
          desc="Sistema criado utilizando uma API externa, do site, openweathermap, onde mostra a temperatura do local no exato momento da requisição."
          src={projectTerm}
          linkGit="https://github.com/pablo-santos21/thermometer"
          linkSite="https://projeto-thermometer-psantos.netlify.app/"
        />
      </div>

      <div className="py-20 items-center justify-center text-center">
        <NavLink
          className="text-md bg-designColor text-darkText font-bold px-6 py-4 hover:bg-[#04cf00] cursor-pointer rounded-full uppercase"
          to="/portifolio"
        >
          Veja Mais
        </NavLink>
      </div>
    </section>
  );
};

export default Projetos;
